export const getBaseUrl = () => {
  return window.agentEnv.agentApiUri;
};
